import React from 'react';

const RadioBoxIconV1 = ({ props }: { props: any }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <circle cx="8" cy="8" r="7" stroke="#94385E" strokeWidth="2" />
    <circle cx="8" cy="8" r="4" fill="#94385E" />
  </svg>
);

export default RadioBoxIconV1;
